import React, { useEffect, useState } from 'react';
import { event } from '../data/masterclass';
type Remaining = {
  days: number;
  hours: number;
  minutes: number;
};
function getRemaining(target: number): Remaining {
  const diff = Math.max(0, target - Date.now());
  return {
    days: Math.floor(diff / 86400000),
    hours: Math.floor(diff / 3600000 % 24),
    minutes: Math.floor(diff / 60000 % 60)
  };
}
export function Countdown() {
  const target = new Date(event.isoDate).getTime();
  const [remaining, setRemaining] = useState<Remaining>(() => getRemaining(target));
  useEffect(() => {
    const id = window.setInterval(() => setRemaining(getRemaining(target)), 30000);
    return () => window.clearInterval(id);
  }, [target]);
  const units: Array<[number, string]> = [[remaining.days, 'Days'], [remaining.hours, 'Hours'], [remaining.minutes, 'Minutes']];
  return <div className="w-full" role="timer" aria-label="Time until the masterclass begins" data-id="element-21" data-mp="15by6dqqwyhnl">
      <p className="text-center text-[11px] font-bold uppercase tracking-overline text-white/45" data-id="element-22" data-mp="y04xe63v9qs3">
        Doors open in
      </p>
      <div className="mt-4 grid grid-cols-3 gap-3 sm:gap-5" data-id="element-23" data-mp="t1tn5u9nte9c">
        {units.map(([value, label]) => <div key={label} className="rounded-2xl border border-gold/35 bg-ink/80 px-2 py-6 text-center sm:py-8" data-id="element-24" data-mp="17q6kaukhh35f">
            <div className="font-display text-6xl font-bold leading-none text-gold tabular-nums sm:text-7xl lg:text-8xl" data-id="element-25" data-mp="f1sq6pwimqz5">
              {String(value).padStart(2, '0')}
            </div>
            <div className="mt-3 text-[11px] font-semibold uppercase tracking-overline text-white/55" data-id="element-26" data-mp="o2qvrcmlr6ju">
              {label}
            </div>
          </div>)}
      </div>
    </div>;
}